import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import HelmetInfo from "Components/HelmetInfo/HelmetInfo";
import ModalRequestAndAddProject from "Components/ModalRequestAndAddProject/ModalRequestAndAddProject";
import { toast } from "react-toastify";
import { collection, doc, getDocs, deleteDoc } from "firebase/firestore";
import { db } from "../../firebase";
import WorkHeaderInfo from "Pages/WorkInformation/WorkHeaderInfo/WorkHeaderInfo";
import { AgGridReact } from "ag-grid-react";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const Messages = () => {
  const { t } = useTranslation();
  const [cards, setCards] = useState([]);
  const [showModal, setShowModalSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const router = useNavigate();

  const columnDefs = [
    {
      headerName: t("Name"),
      field: "name",
      flex: 2,
    },
    {
      headerName: t("Phone"),
      field: "phone",
      flex: 1,
    },
    {
      headerName: "Message",
      field: "message",
      flex: 1,
    },
  ];

  const fetchCards = async () => {
    try {
      const collectionRef = collection(db, "Messages");
      const snapshot = await getDocs(collectionRef);
      const cardsData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      console.log("cardsData", cardsData);
      setCards(cardsData);
    } catch (error) {
      console.error("Error fetching cards:", error);
    }
  };

  const handleDeleteCard = async (cardId) => {
    try {
      const docRef = doc(db, "Messages", cardId);
      await deleteDoc(docRef);
      setCards(cards.filter((card) => card.id !== cardId));
      toast.success(t("CardDeletedSuccessfully"), {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } catch (error) {
      console.error("Error deleting card:", error);
      toast.error(t("CardDeletionFailed"), {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  };

  useEffect(() => {
    fetchCards();
  }, []);

  const handleCloseModal = () => {
    setShowModalSuccess(false);
    router("/home");
  };

  const handleOpenModalSuccess = () => {
    setShowModalSuccess(true);
  };

  return (
    <>
      <HelmetInfo titlePage={t("Messages")} />
      <ModalRequestAndAddProject
        showModal={showModal}
        handleCloseModal={handleCloseModal}
      />
      <div className="project-management-request all-main">
        <WorkHeaderInfo title={t("Messages")} />
        <div className="d-flex justify-content-end"></div>
        <div className="form-project-management">
          <div className="row Servcis-Cards">
            {cards.length > 0 ? (
              <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
                <AgGridReact
                  paginationPageSize={10}
                  columnDefs={columnDefs}
                  rowData={cards}
                />
              </div>
            ) : (
              <p>{t("NoMessages")}</p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Messages;
